module.exports = __webpack_public_path__ + "img/icon-customer.d3f78282.svg";